// ConfirmDialog — the app's confirm modal (replaces window.confirm). Same visual
// pattern as the meeting cancel-confirm: centered icon + title + body, soft cancel,
// primary/danger confirm.
export default function ConfirmDialog({
  icon = "⚠️", title, children,
  confirmLabel = "Confirm", cancelLabel = "Cancel",
  danger = false, busy = false, onConfirm, onCancel,
}) {
  return (
    <div className="modal-overlay is-open" onClick={() => !busy && onCancel?.()}>
      <div className="modal confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal__body">
          <div className="confirm-modal__icon">{icon}</div>
          <h3>{title}</h3>
          {children}
        </div>
        <div className="modal__foot">
          <button type="button" className="btn btn--soft" disabled={busy} onClick={onCancel}>{cancelLabel}</button>
          <button type="button" className={`btn ${danger ? "btn--danger" : "btn--primary"}`} disabled={busy} onClick={onConfirm}>
            {busy ? <span className="btn__spin" /> : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
